import React from 'react'
import { Image } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { SHr, SLoad, SPage, SText, STheme, SView } from 'servisofts-component2'
import Container from '../../Components/Container';
import Verified_icon from '../../Assets/verified_icon.svg';
import MDL from '../../MDL';
import Config from '../../Config';export default class ChecklistFotos extends React.Component {
constructor(props) {
super(props);
this.state = {
loading: true,
error: null,
fotos: [],
};
}

async componentDidMount() {
await this.loadFotosRepo();
}

loadFotosRepo = async () => {
this.setState({ loading: true, error: null });
try {
const fotos = await MDL.checklist.getChecklistRepoFotos();
const rows = (Array.isArray(fotos) ? fotos : [])
.map((item) => ({
id: item?.id,
checklist_id: String(item?.checklist_id ?? ''),
checklist_pregunta_id: String(item?.checklist_pregunta_id ?? ''),
url_path: String(item?.url_path ?? ''),
}))
.sort((a, b) => Number(b?.id || 0) - Number(a?.id || 0));
this.setState({
fotos: rows,
loading: false,
error: null,
});
} catch (error) {
this.setState({
loading: false,
error: error?.message || String(error),
fotos: [],
});
}
}

getImageUri = (urlPath) => {
const raw = String(urlPath || '').trim();
if (!raw) return '';

if (/^https?:\/\//i.test(raw)) {
const apiBase = String(Config?.apis?.api_checklist || '').trim();
const apiOrigin = apiBase ? new URL(apiBase).origin : '';
if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\//i.test(raw) && apiOrigin) {
const parsed = new URL(raw);
return `${apiOrigin}${parsed.pathname}`;
}
return raw;
}
const apiBase = String(Config?.apis?.api_checklist || '').trim();
if (!apiBase) return raw;
const apiOrigin = new URL(apiBase).origin;
return `${apiOrigin}${raw.startsWith('/') ? raw : `/${raw}`}`;
}

renderItem(item, index) {
const hasUrl = !!String(item?.url_path || '').trim();
const imageUri = this.getImageUri(item?.url_path);
return (
<SView
key={String(item?.id ?? index)}
col={"xs-12"}
style={{
borderRadius: 10,
borderWidth: 1,
borderColor: STheme.color.lightGray,
padding: 12,
backgroundColor: STheme.color.primary,
}}
>
<SText font='AlbertSans' bold fontSize={13} color={STheme.color.text}>id: {String(item?.id ?? '-')}</SText>
<SHr height={3} />
<SText font='AlbertSans' fontSize={12} color={STheme.color.text}>checklist_id: {item.checklist_id || '(vacio)'}</SText>
<SHr height={2} />
<SText font='AlbertSans' fontSize={12} color={STheme.color.text}>checklist_pregunta_id: {item.checklist_pregunta_id || '(vacio)'}</SText>
<SHr height={2} />
<SText font='AlbertSans' fontSize={12} color={hasUrl ? STheme.color.success : STheme.color.danger}>
url_path: {item.url_path || '(vacio)'}
</SText>
{hasUrl ? (
<>
<SHr height={8} />
<SView
col={"xs-12"}
style={{
width: '100%',
height: 180,
borderRadius: 8,
overflow: 'hidden',
borderWidth: 1,
borderColor: STheme.color.lightGray,
}}
>
<Image
source={imageUri ? { uri: imageUri } : null}
style={{ width: '100%', height: '100%' }}
resizeMode="cover"
/>
</SView>
</>
) : null}
</SView>
);
}render() {
const { loading, error, fotos } = this.state;
return (
<SPage center disableScroll>
<Container flex>
<SView col={"xs-12"} flex style={{ backgroundColor: STheme.color.card, padding: 16, borderRadius: 16 }}>
<SView col={"xs-12"} center>
<SView col={"xs-12"} center style={{ alignItems: 'center' }} row>
<Verified_icon width={18} height={18} fill={STheme.color.secondary} style={{ marginRight: 8 }} />
<SText font='AlbertSans' center fontSize={20} color={STheme.color.secondary}>FOTOS CHECKLIST</SText>
</SView>
<SHr height={10} />
<SView col={"xs-12"} height={1} style={{ backgroundColor: STheme.color.lightGray }} />
<SHr height={10} />
<SText font='AlbertSans' center fontSize={14} color={STheme.color.text}>Lista obtenida desde checklist/repo</SText>
<SHr height={10} />
</SView>
<SView col={"xs-12"} flex style={{ minHeight: 0 }}>
<ScrollView
style={{ flex: 1, width: '100%' }}
contentContainerStyle={{ paddingBottom: 12 }}
keyboardShouldPersistTaps="handled"
showsVerticalScrollIndicator
>
{loading ? (
<SView col={"xs-12"} center style={{ alignItems: 'center', justifyContent: 'center' }}>
<SLoad />
<SHr height={10} />
<SText center color={STheme.color.text}>Cargando fotos...</SText>
</SView>
) : null}
{error ? (
<SView col={"xs-12"}>
<SText center color={STheme.color.danger}>{error}</SText>
</SView>
) : null}
{!loading && !error && fotos.length <= 0 ? (
<SView col={"xs-12"}>
<SText center>No se encontraron fotos en checklist_detalle.</SText>
</SView>
) : null}
{!loading && !error ? fotos.map((item, index) => (
<SView key={String(item?.id ?? index)} col={"xs-12"}>
{this.renderItem(item, index)}
<SHr height={8} />
</SView>
)) : null}
</ScrollView>
</SView>
</SView>
</Container>
<SHr height={20} />
</SPage>
);
}
}